<template>
    <div>
        <modal name="credit-card-form" width="90%" height="auto" style="left: 0px; width: auto; height: auto; max-width: 900px !important">
            <ion-header>
                <ion-toolbar>
                <ion-title>{{$t('backoffice.cCardSaved.addCreditCard')}}</ion-title>
                <ion-buttons slot="end">
                    <ion-button @click="$modal.hide('credit-card-form')">❌</ion-button>
                </ion-buttons>
                </ion-toolbar>
            </ion-header>
            <div class="modal-content" style="overflow-y: auto;">
                <CreditCardForm :isModal="true" :userId="customerData._id" :clientId="customerId" :customer="customerData" :creditCardId="creditId" @close-modal="handleCloseModal">
                </CreditCardForm>
            </div>
        </modal>
        <ion-loading v-if="spinner" cssClass="my-custom-class"
        :message="$t('frontend.tooltips.loadRestaurant')"></ion-loading>
        <ion-header v-if="!isModal">
            <ion-toolbar>
                <ion-buttons slot="start">
                    <ion-back-button default-href="/myaccount" @click="goBack()"></ion-back-button>
                </ion-buttons>

                <ion-text style="padding: 20px 100px;">
                    <h2>Credit Cards</h2>
                </ion-text>
            </ion-toolbar>
        </ion-header>
        <ion-grid style="margin-top: 20px;">
            <ion-row>
                <ion-chip style="margin-bottom: 20px;" @click="$modal.show('credit-card-form')">
                    <span class="iconify" data-icon="ic:baseline-plus" data-inline="false"></span>
                    {{$t('backoffice.cCardSaved.addCreditCard')}}
                </ion-chip>
                <ion-col size="12" class="report-sec ">
                <table class="report-table">
                    <thead>
                    <tr>
                        <th style="width: 15%;">Card Number</th>
                        <th style="width: 15%;">Expiration Day</th>
                        <th style="width: 10%;">Expiration Month</th>
                        <th style="width: 10%;">Type</th>
                        <th style="width: 25%;">Name</th>
                        <th style="width: 10%;">Action</th>
                        <!-- <th style="width: 10%;">View</th> -->
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="creditCard in allSubscriptions" v-bind:key="creditCard._id">
                        <td>{{ creditCard.tokenizeResp.i4go_maskedcard }}</td>
                        <td>{{ creditCard.tokenizeResp.i4go_expirationmonth }}</td>
                        <td>{{ creditCard.tokenizeResp.i4go_expirationyear }}</td>
                        <td>{{ creditCard.tokenizeResp.i4go_cardtype }}</td>
                        <td>{{ creditCard.request.customer.firstName }} {{ creditCard.request.customer.lastName }}</td>
                        <td>
                            <!--PENDING TO FUTURE-->
                            <!-- <ion-button @click="editCreditCard(creditCard._id)">
                                <ion-icon slot="icon-only" icon="create"></ion-icon>
                            </ion-button> -->
                            <ion-button @click="deleteCreditCard(creditCard._id)">
                                <ion-icon slot="icon-only" icon="trash"></ion-icon>
                            </ion-button>
                        </td>
                    </tr>
                    </tbody>
                </table>
                </ion-col>
            </ion-row>
        </ion-grid>
    </div>
</template>

<script>
import { Api } from '../../backoffice/api/api';
import CreditCardForm from './CreditCardForm.vue';

export default {
        name: 'CreditCard',
        props:{
            isModal:{
                type: Boolean,
                default: false,
            },
            customerr:{
                type: Object,
                default: null
            },
            id: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                allSubscriptions: [],
                paginate: ['allSubscriptions', 'allWaitList'],
                subscriptions: [],
                currPage: 1,
                page: 1,
                totalPages: 0,
                perPageLimit: 10,
                perPageOptions: [10, 25, 50, 100],
                keyList: 0,
                spinner: false,
                customerData:{},
                creditId: '',
                customerId: ''
            };
        },
        components:{
            CreditCardForm
        },
        created(){
            if(this.isModal){
                this.customerId = this.id
            }
            // console.log(this.id)
            this.customerData = this.$store.state.customer
            this.getData()
        
        },
        methods: {
            // go back to my account
            goBack() {
                this.$router.push({ 
                    name: 'Myaccount', 

                });
            },
            handleCloseModal() {
                this.$modal.hide('credit-card-form'); // Cerrar el modal
                //console.log("store subscription::",this.$store.state.subscription)
                this.getData(); // Llamar a getData
            },
            editCreditCard(id){
                // console.log(id);
                this.creditId = id;
                this.$modal.show('credit-card-form');

            },
            ShowMessage(type, message, topic = '') {
                return this.$ionic.alertController
                .create({
                cssClass: 'my-custom-class',
                header: type,
                subHeader: topic,
                message: message,
                buttons: [this.$t('backoffice.form.messages.buttons.ok')],
                })
                .then(a => a.present())
            },

            // delete credit card on file
            deleteCreditCard: async function (id) {
                return this.$ionic.alertController.create({
                    title: this.$t('backoffice.list.messages.confirmDelete'),
                    message: "Delete Credit Card",
                    buttons: [
                    {
                        text: this.$t('backoffice.list.messages.buttons.cancel'),
                        role: 'cancel',
                        handler: () => { }
                    },
                    {
                        text: this.$t('backoffice.list.messages.buttons.delete'),
                        handler: async () => {

                        this.spinner = true
                        // delete credit cards on file
                        await Api.deleteCreditCard('subscription', id)
                        .then(response => {
                            // const index = this.$store.state.subscription.findIndex(a => a._id === id)
                            // if (index !== -1) this.$store.state.subscription.splice(index, 1)
                            //this.allSubscriptions = response;
                            this.getData()
                            this.ShowMessage(this.$t('backoffice.list.messages.infoDeleteSuccess'),
                            this.$t('backoffice.list.messages.messageDeleteSuccessAbout'),
                            this.$t('backoffice.list.messages.deleteSubtitleAbout'));
                            this.spinner = false;
                            // console.log({response})
                            return response;
                        })
                        .catch(e => {
                            e;
                        })

                        }
                    }
                    ]
                }).then(a => a.present());

            },
            getData(reset = false) {
                //this.$store.commit('setSubscription', { records: [], totalCount: [] });
                //  console.log(this.$store.state)
                if (reset) {
                this.page = 1;
                }
                this.spinner = true;
                const params = {
                page: this.page,
                limit: this.perPageLimit,
                customerId: this.customerData._id || this.id
                };
                Api.fetchAll('payments/subscriptions/byCustomer', params).then(response => {
                const totals = response.data?.totalCount[0] || {};
                this.totalPages = Math.ceil(totals.count / this.perPageLimit);
                this.allSubscriptions = (response.data.records || [])
                console.log({response})
                this.spinner = false;
                this.keyList ++;
                }).catch(e => {
                console.log(e)
                this.spinner = false;
                });
            },
        }
    }
    
</script>

<style scoped>
 .report-sec {
    overflow: auto;
}

.report-table {
    border-collapse: collapse;
    width: 98%;
    min-width: 500px;
    border-radius: 10px !important;
    margin: auto;
}

.report-table th,
.report-table td {
    border: 1px solid rgb(216, 216, 216);
    padding: 6px;
    text-align: center;
}

.report-table td:nth-child(2) {
    white-space: pre-wrap;
}

.report-table th {
    background-color: #ececec;
}
</style>